module.exports = __webpack_public_path__ + "img/9788949123219.b31d11d3.jpg";